import { apiClient } from "../util/ApiClient";
import { store } from "../store";
import {
  ORGANIZATION_PATH,
  ORGANIZATION_CHANGE_CAPABILITY_PATH,
  ORGANIZATION_MAKE_OWNER_PATH,
  ORGANIZATION_MAKE_PRIMARY_OWNER_PATH,
  ORGANIZATION_ADD_BANK_PATH,
  ORGANIZATION_BANK_PATH
} from "../config/Api";

export const ORGANIZATION_LOADED = "ORGANIZATION_LOADED";
export const organizationLoaded = organization => ({
  type: ORGANIZATION_LOADED,
  organization
});

export const ORGANIZATION_UPDATED = "ORGANIZATION_UPDATED";
export const organizationUpdated = organization => ({
  type: ORGANIZATION_UPDATED,
  organization
});

export const ORG_USER_UPDATED = "ORG_USER_UPDATED";
export const userUpdated = user => ({
  type: ORG_USER_UPDATED,
  payload: user
});

export const ORG_USER_ADDED = "ORG_USER_ADDED";
export const userAdded = user => ({
  type: ORG_USER_ADDED,
  payload: user
});

export const NEW_PRIMARY_OWNER = "NEW_PRIMARY_OWNER";
export const newPrimaryOwner = uuid => ({
  type: NEW_PRIMARY_OWNER,
  payload: uuid
});

const organizationInitialState = {
  name: null,
  users: []
};
export const organizationReducer = (
  state = organizationInitialState,
  action
) => {
  switch (action.type) {
    case ORGANIZATION_LOADED:
    case ORGANIZATION_UPDATED:
      return {
        ...action.organization
      };
    case ORG_USER_UPDATED:
      const newUsers = state.users.map(
        user => (user.uuid === action.payload.uuid ? action.payload : user)
      );
      return {
        ...state,
        users: newUsers
      };
    case NEW_PRIMARY_OWNER:
      const newUsers2 = state.users.map(user => {
        if (user.uuid === action.payload) {
          return Object.assign({}, user, { is_primary_owner: true });
        } else if (user.is_primary_owner) {
          return Object.assign({}, user, { is_primary_owner: false });
        }
        return user;
      });
      return {
        ...state,
        users: newUsers2
      };
    case ORG_USER_ADDED:
      return {
        ...state,
        users: state.users.concat([action.payload])
      };
    default:
      return state;
  }
};

export const loadOrganization = () => {
  return apiClient()
    .get(ORGANIZATION_PATH)
    .then(response => response.data);
};

export const updateOrganizationName = newName => {
  return apiClient()
    .post(ORGANIZATION_PATH, {
      name: newName
    })
    .then(response => {
      const organization = response.data;
      store.dispatch(organizationUpdated(organization));
      return organization;
    });
};

export const addCapability = (uuid, capability) => {
  return apiClient()
    .post(ORGANIZATION_CHANGE_CAPABILITY_PATH(uuid), {
      action: "add",
      capability
    })
    .then(response => response.data);
};

export const removeCapability = (uuid, capability) => {
  return apiClient()
    .post(ORGANIZATION_CHANGE_CAPABILITY_PATH(uuid), {
      action: "remove",
      capability
    })
    .then(response => response.data);
};

export const makeOwner = uuid => {
  return apiClient()
    .post(ORGANIZATION_MAKE_OWNER_PATH(uuid), {
      owner: true
    })
    .then(response => response.data);
};

export const removeOwner = uuid => {
  return apiClient()
    .post(ORGANIZATION_MAKE_OWNER_PATH(uuid), {
      owner: false
    })
    .then(response => response.data);
};

export const makePrimaryOwner = uuid => {
  return apiClient()
    .post(ORGANIZATION_MAKE_PRIMARY_OWNER_PATH(uuid))
    .then(response => response.data);
};

export const addBank = (public_token, bank_id, bank_name, accounts) => {
  return apiClient()
    .post(ORGANIZATION_ADD_BANK_PATH, {
      public_token,
      bank_id,
      bank_name,
      accounts
    })
    .then(response => response.data);
};

export const removeBank = bank_uuid => {
  return apiClient()
    .delete(ORGANIZATION_BANK_PATH)
    .then(response => response.data);
};



// WEBPACK FOOTER //
// ./frontend/src/actions/organization.js